import type { Category } from '../config/enums';
import { getTemplateStoreCategoryNames } from '../config/templateStoreCategories';
import { getTemplateIdForCategory } from '../utils/templates';
import { createStoreCategories } from './endpoints';

interface SetupTemplateStoreCategoriesParams {
  category: Category;
}

export async function setupTemplateStoreCategories({
  category,
}: SetupTemplateStoreCategoriesParams): Promise<void> {
  const templateMetaSiteId = getTemplateIdForCategory(category);
  if (!templateMetaSiteId) {
    return;
  }

  const categoryNames = getTemplateStoreCategoryNames(templateMetaSiteId);
  if (!categoryNames?.length) {
    return;
  }

  await createStoreCategories({ categoryNames: [...categoryNames] });
}
